import { useState } from 'react';
import { constants } from '../../constants';
import { TextEllipsis } from '../common/TextEllipsis';
import { UseOfProceedsPopup } from './UseOfProceedsPopup';

interface UseOfProceedsProps {
    issuer: string;
    useOfProceeds?: string[];
    useOfProceedsDescription?: string;
}

export function UseOfProceeds({ issuer, useOfProceeds, useOfProceedsDescription }: UseOfProceedsProps) {
    const [visible, setVisible] = useState(false);

    if (!useOfProceeds?.length) return <>{constants.emptyPlaceholder}</>;

    const overlay = <ul>{useOfProceeds.map((p, i) => <li key={i}>{p}</li>)}</ul>;
    const text = useOfProceeds.join(', ');

    if (!useOfProceedsDescription) {
        return <TextEllipsis overlay={overlay}>{text}</TextEllipsis>;
    }

    return (
        <>
            <button className="pseudo-link use-of-proceeds-link" onClick={() => setVisible(true)}>
                <TextEllipsis overlay={overlay}>{text}</TextEllipsis>
            </button>
            {visible && (
                <UseOfProceedsPopup
                    issuer={issuer}
                    useOfProceedsDescription={useOfProceedsDescription}
                    onClose={() => setVisible(false)}
                />
            )}
        </>
    );
}
